import { RouteRecordRaw } from "vue-router";
import { useVdpStore } from "../stores/vdp.store";

const vdpRoutesChildren = () => {
  return [
    {
      path: "new-submission",
      name: "NEW_SUBMISSION",
      meta: {
        breadcrumb: () => {
          const vdpStore = useVdpStore();
          let label = "New Submission";
          let title = "Voluntary Disclosure Program";

          if (vdpStore.readOnlyMode && vdpStore.submissionDetails?.compactSubmissionSequenceNumber) {
            label = vdpStore.submissionDetails.compactSubmissionSequenceNumber;
            title = vdpStore.submissionDetails.compactSubmissionSequenceNumber;
          }
          return { label, title };
        },
        rebrand: true,
      },
      component: () =>
        import("@/views/GovernmentServices/Vdp/SubmissionDetails.vue"),
    },
    {
      path: "",
      name: "VDP_LIST",
      redirect: () => {
        return {
          name: "DRAFTS",
        };
      },
      meta: {
        label: "",
        rebrand: true,
        hideBreadcrumb: true
      },
    },
    {
      path: "drafts",
      name: "DRAFTS",
      component: () => import("@/views/GovernmentServices/Vdp/Vdp.vue"),
      meta: {
        label: "Drafts",
        rebrand: true,
      },
    },
    {
      path: "submitted",
      name: "SUBMITTED",
      component: () => import("@/views/GovernmentServices/Vdp/Vdp.vue"),
      meta: {
        rebrand: true,
        label: "Submitted",
      },
    },
    {
      path: "processed",
      name: "PROCESSED",
      meta: {
        rebrand: true,
        label: "Processed",
      },
      component: () => import("@/views/GovernmentServices/Vdp/Vdp.vue"),
    },
  ];
};

const vdpRoutes: RouteRecordRaw[] = [
  {
    path: "vdp",
    name: "VDP",
    meta: {
      label: "VDP",
      rebrand: true,
    },
    redirect: () => {
      return {
        name: "DRAFTS",
      };
    },
    children: vdpRoutesChildren(),
  },
];

export default vdpRoutes;
